The input parameter for the `postPositionProfileForOpening` mutation.
